"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLE_MAX_COLUMNS = void 0;
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var EditorTypes_1 = require("../../EditorTypes");
var WidgetManager_1 = require("../../WidgetManager");
var TableColumnManager = __importStar(require("./TableColumnManager"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var TableWidgetContext_1 = require("./TableWidgetContext");
var Types_1 = require("Tokens/Types");
var PlaceholderContext_1 = __importDefault(require("Project/QwilrEditor/Placeholder/PlaceholderContext"));
var inversify_react_1 = require("inversify-react");
var classnames_1 = __importDefault(require("classnames"));
var Table_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Table/Table.css");
exports.TABLE_MAX_COLUMNS = 20;
var TableWidgetInner = (function (_super) {
    __extends(TableWidgetInner, _super);
    function TableWidgetInner(props) {
        var _this = _super.call(this, props) || this;
        _this.resizeColumnIndex = null;
        _this.tableElem = null;
        _this.hoveredColumnForDeletionIdx = undefined;
        _this.startResizingColumn = function (border) {
            return function (event) {
                _this.boundingBox = _this.tableElem.getBoundingClientRect();
                event.preventDefault();
                (0, mobx_1.runInAction)(function () {
                    _this.resizeColumnIndex = border;
                    _this.columnBorders = lodash_1.default.cloneDeep(_this.props.columnBorders);
                });
                document.addEventListener("mousemove", _this.resizeColumnDebounced);
                document.addEventListener("mouseup", _this.stopResizing);
            };
        };
        _this.resizeColumn = function (event) {
            event.preventDefault();
            var relX = event.clientX - _this.boundingBox.x;
            var newPosition = (relX / _this.boundingBox.width) * 100;
            var resizer = TableColumnManager.resizeColumnSingle;
            if (_this.props.usingFeature(FeatureFlag_1.FeatureFlag.NewEditorFancyColumns)) {
                resizer = TableColumnManager.resizeColumnsRight;
            }
            resizer = resizer.bind(TableColumnManager);
            var newBorders = resizer(_this.resizeColumnIndex, newPosition, _this.columnBorders);
            _this.columnBorders = newBorders;
        };
        _this.stopResizing = function () {
            _this.resizeColumnIndex = null;
            document.removeEventListener("mousemove", _this.resizeColumnDebounced);
            document.removeEventListener("mouseup", _this.stopResizing);
            _this.saveColumnSize();
        };
        _this.saveColumnSize = function (columnBorders) {
            if (!columnBorders) {
                columnBorders = _this.props.columnBorders;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.ResizeColumns,
                path: _this.props.widgetManager.getPath(_this.props.element),
                columnBorders: lodash_1.default.cloneDeep(_this.columnBorders),
            }));
        };
        _this.resizeColumnDebounced = lodash_1.default.debounce(_this.resizeColumn, 0);
        _this.rows = props.rows;
        _this.columns = props.columns;
        _this.columnBorders = lodash_1.default.cloneDeep(props.columnBorders);
        _this.resizeColumnIndex = null;
        _this.isHoveringOnDelete = false;
        var normalizedColumnBorders = TableColumnManager.normalizeColumnBorders(props.columns, props.columnBorders);
        if (normalizedColumnBorders != props.columnBorders) {
            _this.saveColumnSize(normalizedColumnBorders);
        }
        return _this;
    }
    TableWidgetInner.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.rows != this.props.rows || prevProps.columns != this.props.columns) {
            (0, mobx_1.runInAction)(function () {
                _this.rows = _this.props.rows;
                _this.columns = _this.props.columns;
                _this.columnBorders = lodash_1.default.cloneDeep(_this.props.columnBorders);
            });
        }
    };
    TableWidgetInner.prototype.render = function () {
        var _this = this;
        var className = (0, classnames_1.default)("table-widget__table", "qwilr-table", (0, Table_css_1.qwilrTable)({
            backgroundOn: this.props.style.background.on,
            borderType: this.props.style.border.borderType,
            headerBackgroundOn: this.props.style.header.on,
        }));
        var contentEditable = true;
        var widgetClassName = "table-widget project-block__block-element";
        if (this.isHoveringOnDelete) {
            widgetClassName += " table-widget--delete-hover";
        }
        var widgetManager = this.props.widgetManager;
        return (react_1.default.createElement("div", __assign({ className: widgetClassName }, this.props.attributes),
            react_1.default.createElement("table", { className: className, ref: function (node) {
                    _this.tableElem = node;
                } },
                react_1.default.createElement("colgroup", { contentEditable: false }, this.renderColumnWidths()),
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement(TableWidgetContext_1.TableWidgetContext.Provider, { value: {
                            data: {
                                columns: this.props.columns,
                                rows: this.props.element.children.length,
                            },
                            cellsAreEditable: widgetManager.canEdit && contentEditable,
                            actions: {
                                addRow: function (_a) {
                                    var referenceRow = _a.referenceRow, direction = _a.direction, type = _a.type;
                                    if (type === "regular") {
                                        _this.addRow(referenceRow, direction)();
                                    }
                                    else {
                                        _this.addRepeatingRow(referenceRow, direction)();
                                    }
                                },
                                deleteRow: function (row) {
                                    _this.deleteRows([row])();
                                },
                                addColumn: function (column, direction) {
                                    _this.addColumn(column + (direction === "before" ? 0 : 1))();
                                },
                                deleteColumn: function (column) {
                                    _this.deleteColumns([column])();
                                    _this.hoveredColumnForDeletionIdx = undefined;
                                },
                                hoverColumnForDeletion: function (currentColumnIndex) {
                                    (0, mobx_1.runInAction)(function () {
                                        _this.hoveredColumnForDeletionIdx = currentColumnIndex;
                                    });
                                },
                            },
                            enableRepeatingTableRows: this.props.enableRepeatingTableRows,
                            hoveredColumnForDeletionIdx: this.hoveredColumnForDeletionIdx,
                            isResizingColumns: this.resizeColumnIndex != undefined,
                            style: this.props.style,
                        } },
                        react_1.default.createElement(PlaceholderContext_1.default, { placeholders: { heading1: null, heading2: null, paragraph: null } }, this.props.children)))),
            widgetManager.canEdit && react_1.default.createElement("div", { contentEditable: false }, this.renderSizeModifiers())));
    };
    TableWidgetInner.prototype.renderColumnWidths = function () {
        var columns = [];
        for (var i = 0; i < this.props.columns; i++) {
            var width = this.getColumnBorder(i + 1) - this.getColumnBorder(i);
            var key = "colWidth-".concat(i);
            var col = react_1.default.createElement("col", { style: { width: "".concat(width, "%") }, key: key });
            columns.push(col);
        }
        return columns;
    };
    TableWidgetInner.prototype.getColumnBorder = function (idx) {
        if (this.resizeColumnIndex != null) {
            return this.columnBorders[idx];
        }
        return this.props.columnBorders[idx];
    };
    TableWidgetInner.prototype.renderSizeModifiers = function () {
        var resizers = [];
        for (var border = 1; border < this.columns; border++) {
            var percentage = this.getColumnBorder(border);
            var position = "calc(".concat(percentage, "% - 4.5px)");
            var className = "table-widget__column-resizer";
            if (this.resizeColumnIndex == border) {
                className += " ".concat(className, "--resizing");
            }
            var key = "border-".concat(border);
            resizers.push(react_1.default.createElement("div", { "data-interactive-zone": true, key: key, className: className, style: { left: position }, onMouseDown: this.startResizingColumn(border) }));
        }
        return resizers;
    };
    TableWidgetInner.prototype.addColumn = function (columnIdx) {
        var _this = this;
        return function () {
            var newColumnBorders = TableColumnManager.addColumn(columnIdx, _this.props.columnBorders);
            newColumnBorders = TableColumnManager.normalizeColumnBorders(_this.props.columns + 1, newColumnBorders);
            (0, mobx_1.runInAction)(function () {
                _this.columns = _this.props.columns;
                _this.columnBorders = newColumnBorders;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.AddColumn,
                path: _this.props.widgetManager.getPath(_this.props.element),
                column: columnIdx,
                columnBorders: lodash_1.default.cloneDeep(newColumnBorders),
            }));
        };
    };
    TableWidgetInner.prototype.deleteColumns = function (columnIdxs) {
        var _this = this;
        return function () {
            var e_1, _a;
            var newColumnBorders = _this.props.columnBorders;
            try {
                for (var columnIdxs_1 = __values(columnIdxs), columnIdxs_1_1 = columnIdxs_1.next(); !columnIdxs_1_1.done; columnIdxs_1_1 = columnIdxs_1.next()) {
                    var columnIdx = columnIdxs_1_1.value;
                    newColumnBorders = TableColumnManager.removeColumn(columnIdx, newColumnBorders);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (columnIdxs_1_1 && !columnIdxs_1_1.done && (_a = columnIdxs_1.return)) _a.call(columnIdxs_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            newColumnBorders = TableColumnManager.normalizeColumnBorders(_this.props.columns - columnIdxs.length, newColumnBorders);
            (0, mobx_1.runInAction)(function () {
                _this.columns = _this.props.columns - columnIdxs.length;
                _this.columnBorders = newColumnBorders;
                _this.isHoveringOnDelete = false;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.DeleteColumns,
                path: _this.props.widgetManager.getPath(_this.props.element),
                columns: columnIdxs,
                columnBorders: lodash_1.default.cloneDeep(newColumnBorders),
            }));
        };
    };
    TableWidgetInner.prototype.addRow = function (rowIdx, direction) {
        var _this = this;
        return function () {
            (0, mobx_1.runInAction)(function () {
                _this.rows = _this.props.rows + 1;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.AddRow,
                path: _this.props.widgetManager.getPath(_this.props.element),
                row: rowIdx,
                direction: direction,
            }));
        };
    };
    TableWidgetInner.prototype.addRepeatingRow = function (rowIdx, direction) {
        var _this = this;
        if (direction === void 0) { direction = "below"; }
        return function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.AddRepeatingRow,
                path: _this.props.widgetManager.getPath(_this.props.element),
                row: rowIdx,
                direction: direction,
            }));
        };
    };
    TableWidgetInner.prototype.deleteRows = function (rowIdxs) {
        var _this = this;
        return function () {
            (0, mobx_1.runInAction)(function () {
                _this.rows = _this.props.rows - rowIdxs.length;
                _this.isHoveringOnDelete = false;
            });
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("table", {
                action: EditorTypes_1.TableActionType.DeleteRows,
                path: _this.props.widgetManager.getPath(_this.props.element),
                rows: rowIdxs,
            }));
        };
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], TableWidgetInner.prototype, "rows", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], TableWidgetInner.prototype, "columns", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], TableWidgetInner.prototype, "columnBorders", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TableWidgetInner.prototype, "resizeColumnIndex", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], TableWidgetInner.prototype, "isHoveringOnDelete", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TableWidgetInner.prototype, "hoveredColumnForDeletionIdx", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TableWidgetInner.prototype, "resizeColumn", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TableWidgetInner.prototype, "stopResizing", void 0);
    TableWidgetInner = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TableWidgetInner);
    return TableWidgetInner;
}(react_1.default.Component));
var enableTokens = function (widgetManager, blockStore) {
    if (widgetManager.isInTemplate()) {
        return Types_1.TokensEnableState.EnabledWithAllInteractions;
    }
    if (blockStore.isSavedBlock) {
        return Types_1.TokensEnableState.EnabledWithoutDragAndDrop;
    }
    return Types_1.TokensEnableState.Disabled;
};
var enableRepeatingTableRows = function (usingFeature, widgetManager, blockStore) {
    if (!usingFeature(FeatureFlag_1.FeatureFlag.PublicApi)) {
        return Types_1.TokensEnableState.Disabled;
    }
    return enableTokens(widgetManager, blockStore);
};
var TableWidget = function (_a) {
    var element = _a.element, attributes = _a.attributes, children = _a.children, style = _a.style;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    return (react_1.default.createElement(TableWidgetInner, { rows: element.data.rows, columns: element.data.columns, attributes: attributes, element: element, children: children, usingFeature: usingFeature, columnBorders: element.data.columnBorders, widgetManager: widgetManager, enableRepeatingTableRows: enableRepeatingTableRows(usingFeature, widgetManager, blockStore), style: style }));
};
exports.default = TableWidget;
